import { Badge, Box, useDisclosure } from '@chakra-ui/react';
import { ButtonGroup, Chip, Skeleton } from '@mui/material';
import axios from 'axios';
import Card from 'components/card';
import MButton from 'components/Mbutton';
import MenuDrop from 'components/MenuDrop';
import MuiDatePicker from 'components/MuiDatePicker';
import MuiSelect from 'components/MuiSelect';
import MuiTable from 'components/MuiTable';
import PaginateBox from 'components/PaginateBox';
import SearchModal from 'components/SearchModal';
import CheckAuthorization from 'components/security/CheckAutorization';
import { FromArchiveIcon, FromTheFieldIcon } from 'components/TableIcon';
import { CHECK_PERMISSIONS, ENTERPRISE_HEADER, ROLES_LIST } from 'Constaints';
import useDataFetching from 'hooks/useDataFetching';
import { useEffect, useState } from 'react';
import { useAuthHeader, useAuthUser } from 'react-auth-kit';
import { useTranslation } from 'react-i18next';
import {
  BsGeoAlt,
  BsList,
  BsMinecart,
  BsPersonFill,
  BsPlusCircle,
  BsSearch,
  BsThreeDotsVertical,
  BsXCircle,
} from 'react-icons/bs';
import { useLocation, useNavigate } from 'react-router-dom';
import { castToRequestParams, createMapLink, formatDate, formatNumber } from 'utils';
import { config } from 'variables/config';
import PrintButtonExcel from '../default/components/PrintButtonExcel';
import EmployesByEnterpriseModal from '../employes/EmployesByEnterpriseModal';
import AddEnterprise from './AddEnterprise';

const Enterprises = () => {
  const { t } = useTranslation('enterprises');
  const [open, setOpen] = useState(false);
  const authHeader = useAuthHeader();
  const location = useLocation();
  const handleClose = () => {
    setSelectedEnterprise(null);
    setOpen(false);
  };
  const navigation = useNavigate();

  // Traduire les labels de ENTERPRISE_HEADER
  const translatedHeaders = ENTERPRISE_HEADER.map((header) => ({
    ...header,
    label: t(header.label),
  }));

  const [enterprises, setEnterprises] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(null);

  const [loadingR, errorR, regions, fetchDataR] = useDataFetching(`${config.app.api_url}/regions`);

  const [loadingM, errorM, missions, fetchDataM] = useDataFetching(
    `${config.app.api_url}/missions`
  );

  const [loadingSearch, errorSearch, searchEnterprises, fetchDataSearch] = useDataFetching(
    searchTerm?.length > 2
      ? `${config.app.api_url}/enterprises/search-with-deleted/${searchTerm}`
      : null
  );

  const [region, setRegion] = useState('*');
  const [departement, setDepartement] = useState(null);

  useEffect(() => {
    setRegion(location?.state?.regionId);
  }, [location]);

  const [arrondissement, setArrondissement] = useState(null);

  useEffect(() => {
    setDepartement(location?.state?.departmentId);
  }, [location]);

  const [loadingD, errorD, departements, fetchDataD] = useDataFetching(
    region && region !== '*' ? `${config.app.api_url}/regions/${region}/departments` : null
  );

  const [loadingA, errorA, arrondisements, fetchDataA] = useDataFetching(
    departement ? `${config.app.api_url}/departments/${departement}/arrondissements` : null
  );

  const [loadingZ, errorZ, zones, fetchZones] = useDataFetching(
    region && region != '*'
      ? `${config.app.api_url}/regions/${region}/zones`
      : `${config.app.api_url}/zones`
  );

  const auth = useAuthUser();
  const [loadingU, errorU, user, fetchDataU] = useDataFetching(
    `${config.app.api_url}/users/${auth()?.user?.id}`
  );

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedEnterprise, setSelectedEnterprise] = useState(null);
  const [openList, setOpenList] = useState(false);

  const [params, setParams] = useState({
    enterpriseId: location.state?.enterpriseId,
    start: location.state?.start,
    end: location.state?.end,
    startUpdate: location.state?.startUpdate,
    endUpdate: location.state?.endUpdate,
    isRegular: location.state?.isRegular,
    regionId: location.state?.regionId,
    departmentId: location.state?.departmentId,
    arrondissementId: location.state?.arrondissementId,
    page: 0,
    limit: 50,
    fromArchive: location.state?.fromArchive,
    located: location.state?.located,
    creatorId: location.state?.creator?.id,
    zoneId: location.state?.zone?.id,
    missionId: location.state?.mission?.id,
    taskId: location.state?.task?.id,
  });

  const [creator, setCreator] = useState(null);
  const [mission, setMission] = useState(null);
  const [zone, setZone] = useState(null);
  const [task, setTask] = useState(null);
  const [hideOptions, setHideOptions] = useState(false);

  useEffect(() => {
    if (creator || mission || zone || task) {
      setHideOptions(true);
    }
  }, [creator, mission, zone, task]);

  useEffect(() => {
    if (location.state) {
      setCreator(location.state?.creator);
      setMission(location.state?.mission);
      setZone(location.state?.zone);
      setTask(location.state?.task);
      setParams({
        enterpriseId: location.state?.enterpriseId,
        start: location.state?.start,
        end: location.state?.end,
        startUpdate: location.state?.startUpdate,
        endUpdate: location.state?.endUpdate,
        isRegular: location.state?.isRegular,
        regionId: location.state?.regionId,
        departmentId: location.state?.departmentId,
        arrondissementId: location.state?.arrondissementId,
        page: 0,
        limit: 50,
        fromArchive: location.state?.fromArchive,
        located: location.state?.located,
        creatorId: location.state?.creator?.id,
        zoneId: location.state?.zone?.id,
        missionId: location.state?.mission?.id,
        taskId: location.state?.task?.id,
      });
    }
  }, [location]);

  const get = () => {
    axios
      .get(`${config.app.api_url}/enterprises/query-names-only?${castToRequestParams(params)}`, {
        headers: {
          Authorization: authHeader(),
        },
      })
      .then((res) => {
        setEnterprises(res?.data?.data);
      })
      .catch((err) => {
        console.log(err);
        setEnterprises([]);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setLoading(true);
    get();
  }, [params]);
  const HeaderTable = [
    '#',
    t('header_social_reason'),
    t('header_niu'),
    t('header_sigle'),
    t('header_activity_sector'),
    t('header_employees_number'),
    t('header_arrondissement'),
    t('header_street'),
    t('header_contacts'),
  ];

  const exportPdf = (
    <PrintButtonExcel
      text={t('menu_export')}
      filename={
        'Entreprises_' +
        regions?.data?.find((r) => r?.id == params?.regionId)?.name +
        `_page_${params?.page}SUR${enterprises?.totalPages}`
      }
      header={HeaderTable}
      body={enterprises?.content?.map((e, index) => {
        return [
          index + 1,
          e?.socialRaison?.toUpperCase(),
          e?.nui?.toUpperCase(),
          e?.sigle?.toUpperCase(),
          e?.activity?.toUpperCase(),
          e?.region?.toUpperCase(),
          e?.arrondissement?.toUpperCase(),
        ];
      })}
    />
  );

  const menu = {
    icon: <BsThreeDotsVertical />,
    label: t('menu_options'),
    Items: [
      {
        label: t('menu_add_enterprise'),
        icon: <BsPlusCircle />,
        handleClick: () => setOpen(true),
      },
      {
        label: null,
        icon: exportPdf,
      },
      {
        label: t('menu_reset_filter'),
        icon: <BsXCircle />,
        handleClick: () => alert('building'),
      },
    ],
  };

  const handleClick = (item) => {
    if (item) {
      setSelectedEnterprise(item);
      setOpen(true);
    }
  };

  function createData(N, Raison, Secteur, Arrondissement, Expatriés, Coordonnées, Options) {
    return { N, Raison, Secteur, Arrondissement, Expatriés, Coordonnées, Options };
  }

  const rows = !enterprises?.content
    ? []
    : enterprises?.content?.map((item, index) => {
        return {
          handleClick: () => handleClick(item),
          datas: createData(
            params?.page * params?.limit + (index + 1),
            <>
              {item?.fromArchive ? <FromArchiveIcon /> : <FromTheFieldIcon />}
              <span className="fs-c">{item?.socialRaison}</span>
            </>,
            item?.activity,
            item?.arrondissement,
            item?.employeesNumber != null ? item?.employeesNumber : '--',
            user?.data?.roles.length > 0 &&
              user?.data?.roles?.map((role) =>
                CHECK_PERMISSIONS(role?.permissions, 'Voir une entreprise sur google map') ? (
                  <>
                    {item?.latitude && item?.longitude ? (
                      <Chip
                        icon={<BsGeoAlt />}
                        color="primary"
                        className="capitalize-none"
                        variant="outlined"
                        label={t('action_view_on_map')}
                        onClick={(e) => {
                          e.preventDefault();
                          e?.stopPropagation();
                          if (item?.latitude && item?.longitude) {
                            window.open(
                              createMapLink(`${item?.latitude},${item?.longitude}`),
                              '_blank',
                              'noopener,noreferrer'
                            );
                          } else {
                            alert(t('error_incomplete_coordinates'));
                          }
                        }}
                      />
                    ) : item?.searchLatitude && item?.searchLongitude ? (
                      <Chip
                        icon={<BsGeoAlt />}
                        color="warning"
                        className="capitalize-none"
                        variant="outlined"
                        label={t('action_verify_on_map')}
                        onClick={(e) => {
                          e.preventDefault();
                          e?.stopPropagation();
                          if (item?.searchLatitude && item?.searchLongitude) {
                            window.open(
                              createMapLink(`${item?.searchLatitude},${item?.searchLongitude}`),
                              '_blank',
                              'noopener,noreferrer'
                            );
                          } else {
                            alert(t('error_incomplete_coordinates'));
                          }
                        }}
                      />
                    ) : (
                      <Chip
                        icon={<BsSearch />}
                        className="capitalize-none"
                        label={t('action_search_on_map')}
                        onClick={(e) => {
                          e.preventDefault();
                          e?.stopPropagation();
                          window.open(
                            createMapLink(
                              `${item?.socialRaison} ${item?.sigle} ${item?.street} CAMEROON`
                            ),
                            '_blank',
                            'noopener,noreferrer'
                          );
                        }}
                      />
                    )}
                  </>
                ) : (
                  <></>
                )
              ),
            <MButton
              variant={'white'}
              onClick={(e) => {
                setSelectedEnterprise(item);
                e.preventDefault();
                e?.stopPropagation();
                setOpenList(true);
              }}
            >
              <BsList />
              {t('action_view_expatriates')}
            </MButton>
          ),
        };
      });

  return (
    <div>
      <div className="grid h-full grid-cols-1 gap-5">
        {loadingR ? (
          <Skeleton variant="rectangular" width={'100%'} height={90} />
        ) : (
          <Box
            bg={'rgba(255, 255, 255, 1)'}
            boxShadow="lg"
            p={2}
            rounded={'md'}
            border="1px"
            borderColor="gray.200"
            className="flex flex-wrap gap-1 items-end justify-end"
          >
            <MuiDatePicker
              label={t('filter_start_period')}
              value={params?.start}
              onChange={(newValue) => {
                setParams({
                  ...params,
                  start: new Date(newValue)?.getTime(),
                });
              }}
              wrapperClasses={'flex-1 filter-item anime slideLeft'}
            />
            <MuiDatePicker
              value={params?.end}
              label={t('filter_end_period')}
              onChange={(newValue) => {
                setParams({
                  ...params,
                  end: new Date(newValue)?.getTime(),
                });
              }}
              wrapperClasses={'flex-1 filter-item anime slideLeft'}
            />
            <MuiDatePicker
              label={t('filter_start_update')}
              value={params?.startUpdate}
              onChange={(newValue) => {
                setParams({
                  ...params,
                  startUpdate: new Date(newValue)?.getTime(),
                });
              }}
              wrapperClasses={'flex-1 filter-item anime slideLeft'}
            />
            <MuiDatePicker
              value={params?.endUpdate}
              label={t('filter_end_update')}
              onChange={(newValue) => {
                setParams({
                  ...params,
                  endUpdate: new Date(newValue)?.getTime(),
                });
              }}
              wrapperClasses={'flex-1 filter-item anime slideLeft'}
            />
            <MuiSelect
              label={t('filter_region')}
              options={regions?.data}
              emptyLabel={t('option_national')}
              value={params?.regionId}
              defaultFormat={true}
              onChange={(e) => {
                setRegion(e.target.value);
                setArrondissement('');
                setDepartement('');
                setParams({
                  ...params,
                  regionId: e.target.value,
                  departmentId: null,
                  arrondissementId: null,
                });
              }}
              wrapperClasses={'flex-1 filter-item anime slideLeft'}
            />
            {departements?.data && (
              <MuiSelect
                label={t('filter_department')}
                options={departements?.data}
                emptyLabel={t('option_regional')}
                value={params?.departmentId}
                defaultFormat={true}
                onChange={(e) => {
                  setDepartement(e.target.value);
                  setArrondissement('');
                  setParams({
                    ...params,
                    departmentId: e.target.value,
                    arrondissementId: null,
                  });
                }}
                wrapperClasses={'flex-1 filter-item anime slideDown'}
              />
            )}
            {zones?.data && (
              <MuiSelect
                label={t('filter_zone')}
                value={params.zoneId}
                options={zones?.data?.map((z) => ({
                  value: z?.id,
                  label: `Zone ${z?.number} ${z?.description ? '--' + z?.description : ''}`,
                }))}
                onChange={(e) => {
                  setArrondissement(e.target.value);
                  setParams({
                    ...params,
                    zoneId: e.target.value,
                  });
                }}
                emptyLabel={t('option_none')}
              />
            )}
            {arrondisements?.data && (
              <MuiSelect
                label={t('filter_arrondissement')}
                emptyLabel={t('option_departmental')}
                options={arrondisements?.data}
                value={params?.arrondissementId}
                defaultFormat={true}
                onChange={(e) => {
                  setArrondissement(e.target.value);
                  setParams({
                    ...params,
                    arrondissementId: e.target.value,
                  });
                }}
                wrapperClasses={'flex-1 filter-item anime slideDown'}
              />
            )}
            {missions?.data && (
              <MuiSelect
                label={t('filter_mission')}
                value={params.missionId}
                options={[
                  { value: '-1', label: t('option_no_control_mission') },
                  { value: '-2', label: t('option_completed_control_mission') },
                  ...missions?.data?.map((m) => ({
                    value: m?.id,
                    label: `${m?.description} du ${formatDate(m?.start)} ${formatDate(m?.end)}`,
                  })),
                ]}
                onChange={(e) => {
                  setArrondissement(e.target.value);
                  setParams({
                    ...params,
                    missionId: e.target.value,
                  });
                }}
                emptyLabel={t('option_none')}
              />
            )}
            <MuiSelect
              label={t('filter_is_regular')}
              emptyLabel={t('option_all')}
              options={[
                { value: false, label: t('option_no') },
                { value: true, label: t('option_yes') },
              ]}
              value={params?.isRegular}
              onChange={(value) => {
                alert(t('error_functionality_under_maintenance'));
                setParams({
                  ...params,
                  isRegular: null,
                });
              }}
              wrapperClasses={'flex-1 filter-item anime slideRight'}
            />
            <MuiSelect
              label={t('filter_source')}
              emptyLabel={t('option_all')}
              value={params?.fromArchive}
              options={[
                { value: false, label: t('option_field') },
                { value: true, label: t('option_archive') },
              ]}
              onChange={(value) => {
                setParams({
                  ...params,
                  fromArchive: value.target.value,
                });
              }}
              wrapperClasses={'flex-1 filter-item anime slideRight'}
            />
            <MuiSelect
              label={t('filter_located')}
              emptyLabel={t('option_all')}
              options={[
                { value: false, label: t('option_no') },
                { value: true, label: t('option_yes') },
              ]}
              value={params?.located}
              onChange={(value) => {
                setParams({
                  ...params,
                  located: value.target.value != '-1' ? value.target.value : null,
                });
              }}
              wrapperClasses={'flex-1 filter-item anime slideRight'}
            />
            <div className="anime slideRight">
              <MenuDrop menu={menu} />
            </div>
          </Box>
        )}
        {creator && (
          <Box
            bg={'yellow.100'}
            boxShadow="lg"
            p={2}
            rounded={'md'}
            border="1px"
            borderColor="gray.200"
            className="flex flex-wrap gap-1 items-end justify-center"
          >
            <span className="flex gap-2">
              <BsPersonFill size={20} className="text-blue-400" />
              {t('context_collected_by')}
              <strong>
                {creator?.creator?.firstName} {creator?.lastName}
              </strong>
            </span>
          </Box>
        )}
        {mission && (
          <Box
            bg={'yellow.100'}
            boxShadow="lg"
            p={2}
            rounded={'md'}
            border="1px"
            borderColor="gray.200"
            className="flex flex-wrap gap-1 items-end justify-center"
          >
            <span className="flex gap-2">
              {t('context_collected_during_mission')}
              <strong>
                {` ${mission?.description} du : ${formatDate(mission?.start)} au: ${formatDate(mission?.end)}`}
              </strong>
            </span>
          </Box>
        )}
        {zone && (
          <Box
            bg={'yellow.100'}
            boxShadow="lg"
            p={2}
            rounded={'md'}
            border="1px"
            borderColor="gray.200"
            className="flex flex-wrap gap-1 items-end justify-center"
          >
            <span className="flex gap-2">
              <BsPersonFill size={20} className="text-blue-400" />
              {t('context_collected_in_zone')}
              <strong>{` Zone ${zone?.number} -- ${zone?.description}`}</strong>
            </span>
          </Box>
        )}
        {task && (
          <Box
            bg={'yellow.100'}
            boxShadow="lg"
            p={2}
            rounded={'md'}
            border="1px"
            borderColor="gray.200"
            className="flex flex-wrap gap-1 items-end justify-center"
          >
            <span className="flex flex-col gap-0">
              <span className="flex">
                <BsPersonFill size={20} className="text-blue-400" />
                {t('context_assigned_to_task')}
                <strong>{task?.description}</strong>
              </span>
              <span className="w-full flex flex-wrap gap-1">
                {task?.participants?.map((p) => (
                  <Chip
                    key={p.id}
                    color="info"
                    variant="outlined"
                    label={`${p?.firstName} ${p?.lastName}`}
                  />
                ))}
              </span>
            </span>
          </Box>
        )}
        <Card extra={'w-full h-full pb-4'}>
          <div className="flex justify-between">
            <div>
              <strong>
                {t('label_total')}
                <Badge
                  fontSize={13}
                  rounded={5}
                  padding={1}
                  paddingInline={2}
                  colorScheme="green"
                  className="m-0 ms-2"
                >
                  {formatNumber(enterprises?.totalElements) || '--'}
                </Badge>
              </strong>
            </div>
            <div className="flex flex-1 justify-center">
              <span style={{ marginTop: -15 }}>
                <ButtonGroup variant="text" aria-label="Basic button group">
                  {!hideOptions && (
                    <>
                      <MButton
                        variant={params?.creatorId === auth()?.user?.id ? 'primary' : 'white'}
                        onClick={() =>
                          setParams({
                            ...params,
                            creatorId: params?.creatorId ? null : auth()?.user?.id,
                          })
                        }
                      >
                        <BsMinecart />
                        {t('my_work')}
                      </MButton>
                      <SearchModal
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        searchResults={searchEnterprises?.data}
                        searchFunction={fetchDataSearch}
                        iconLabel={t('action_search')}
                        placeholder={t('search_modal_placeholder')}
                        title={t('search_modal_title')}
                        handleClickResult={(item) => {
                          setSelectedEnterprise(item);
                          setOpen(true);
                        }}
                        loading={loadingSearch}
                      />
                      <CheckAuthorization
                        roles={[
                          ROLES_LIST.ADMIN,
                          ROLES_LIST.AGENT,
                          ROLES_LIST.QUALITY,
                          ROLES_LIST.DRMO,
                        ]}
                      >
                        <MButton variant={'white'} onClick={() => setOpen(true)}>
                          <BsPlusCircle />
                          {t('action_add')}
                        </MButton>
                      </CheckAuthorization>
                    </>
                  )}
                  <CheckAuthorization
                    roles={[
                      ROLES_LIST.ADMIN,
                      ROLES_LIST.AGENT,
                      ROLES_LIST.QUALITY,
                      ROLES_LIST.DRMO,
                    ]}
                  >
                    {exportPdf}
                  </CheckAuthorization>
                </ButtonGroup>
              </span>
            </div>
          </div>
          <MuiTable
            loading={loading}
            columns={translatedHeaders}
            limit={params?.limit}
            hidePagiation={true}
            rows={rows}
          />
          <PaginateBox
            total={enterprises?.totalElements}
            rowsPerPage={params?.limit}
            handleChangeRowsPerPage={(event) => {
              setParams({
                ...params,
                limit: parseInt(event.target.value),
                page: 0,
              });
            }}
            page={params.page}
            count={enterprises?.totalPages - 1}
            handleChange={(event, value) => {
              setParams({ ...params, page: value });
            }}
          />
        </Card>
      </div>
      <AddEnterprise
        get={get}
        open={open}
        handleClose={handleClose}
        selectedEnterpriseP={selectedEnterprise}
      />
      <EmployesByEnterpriseModal
        Fullscreen={true}
        title={t('modal_title_1')}
        open={openList}
        setOpen={setOpenList}
        handleClose={() => {
          setOpenList(false);
          setSelectedEnterprise(null);
        }}
        selectedEnterprise={selectedEnterprise}
      />
    </div>
  );
};

export default Enterprises;
